export const style = {
  '& .greeting-date': {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '1.125rem',
    lineHeight: '24px'
  },
  '& .greeting-msg': {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '2.25rem',
    lineHeight: '44px'
  }
};
